import React, { useEffect, useContext } from "react";
import { Row, Col } from "reactstrap";
import headerlogo from "../../../../images/firstpasslogo.svg";
import headerlogoDark from "../../../../images/firstpasslogo-dark.svg";
import { useSelector, useDispatch } from "react-redux";
import { interval } from "rxjs";
import { ParentContext } from "../../Container/kioskcontext";
import { getCurrentDateTimeRequest } from "../../../../store/actions";
import { getDateTimeInterval } from "../../../../helpers/helpersIndex";
import clientLogo from "../../../../images/vmcare-light.svg";
import clientLogoDark from "../../../../images/vmcare-dark.svg";
import fp from "../../../../images/firstpasslogo.svg";
import vmcare from "../../../../images/vmcare_logo.svg";
import moment from "moment";

let subscribe;

const ThemeOneTopBar: React.FC = () => {
  // Function to get the appropriate image based on body class
  const getSiteLogo = (): string => {
    const bodyClass = document.body.className;
    // You can add more conditions based on your theme classes
    switch (true) {
      case bodyClass.includes("blue"):
        return headerlogo;
      case bodyClass.includes("dark"):
        return headerlogo;
      case bodyClass.includes("light"):
        return headerlogoDark;
      default:
        return headerlogo; // Default image
    }
  };

  const getClientLogo = (): string => {
    const bodyClass = document.body.className;
    switch (true) {
      case bodyClass.includes("blue"):
        return clientLogo;
      case bodyClass.includes("dark"):
        return clientLogo;
      case bodyClass.includes("light"):
        return clientLogoDark;
      default:
        return clientLogo;
    }
  };

  const dispatch = useDispatch();
  const context = useContext(ParentContext);

  const dataTime = useSelector((state: any) => {
    if (state?.kioskReducer?.dateTime) return true;
    else return false;
  });

  useEffect(() => {
    dispatch(getCurrentDateTimeRequest());
    subscribe = interval(1000 * getDateTimeInterval()).subscribe((x) => {
      dispatch(getCurrentDateTimeRequest());
    });
    return () => {
      if (subscribe) subscribe.unsubscribe();
    };
  }, []);

  return (
    <>
      {/* Header */}

      <div className="topbar">
        <img src={fp} alt="" width="200" />

        <div className="Kiosk_timer">
          {/* {dataTime && <context.ThemeOneTime />} */}
          <h6>{moment(new Date()).format("HH:MM A")}</h6>
          {/* <span>Tuesday, 15 April 2025</span> */}
          <span>{moment(new Date()).format("dddd, D MMMM  YYYY")}</span>
        </div>
        <img src={vmcare} alt="" width="180" />
      </div>
    </>
  );
};
export default React.memo(ThemeOneTopBar);
